"use client";

import { useRef } from "react";
import type { SearchEntry } from "../types";
import { ASSET_TYPES } from "../constants";
import { fetchRecentlyUpdated } from "./fetchers";
import { useAsyncData } from "./useAsyncData";

const EMPTY: SearchEntry[] = [];

interface UseRecentlyUpdatedOptions {
  /**
   * Arms the request. Callers that mount this hook before the user can see the
   * result (global search keeps it above its popover so the list survives
   * close/reopen) pass `false` until the dropdown is first opened.
   */
  initiallyEnabled?: boolean;
}

export function useRecentlyUpdated({
  initiallyEnabled = true,
}: UseRecentlyUpdatedOptions = {}) {
  // One-way on purpose: a caller that gates on "is the dropdown open" rather
  // than "has it ever been opened" must not refetch on every reopen.
  const armed = useRef(false);
  if (initiallyEnabled) armed.current = true;

  const { data, loading, error } = useAsyncData(
    ["recentlyUpdated"],
    (signal) => fetchRecentlyUpdated(ASSET_TYPES, 5, signal),
    { enabled: armed.current },
  );

  return { items: data?.recentZapierAssets ?? EMPTY, loading, error };
}
